<template>
    <v-combobox
        v-model="childData"
        :label="label"
        :rules="rules"
        :items="items"
        :filter="filter"
        item-text="name"
        clearable
    ></v-combobox>
</template>
<script>
import CommonDataService from '../services/CommonDataService'
import ComboBoxUtil from '../utils/ComboBoxUtil'
export default {
    name: "agency-combo",
    props:{
        value: Object,
        label: String,
        rules: Array
    },
    data(){
        return {
            childData: this.value,
            items: [],
            nonceCount: 0
        }
    },
    created() {
        //response要用(response), 不可以用function(response)
        CommonDataService.findAgencyCompanies().then((response) => {
                this.items = response.list
                this.nonceCount = this.items.length 
            }).catch(function (error) {
                console.log(error)
            })
    },
    computed: {

        itemCount(){
            return (this.result === null) ? 0 : this.result.list.length
        }
    },

    watch:{
        value(val){
            //this.childData = this.getModel(val)
            this.childData = ComboBoxUtil.getComboBoxModel(val,this.items,{id:-1, name:''})
        },
        childData(val){
            //this.$emit('input', this.getModel(val))  
            this.$emit('input', ComboBoxUtil.getComboBoxModel(val,this.items,{id:-1, name:''}))  
        }
    },
    methods:{
        filter(val, queryText, itemText){
            //console.log('AgencyCombo. filter, val =')
            //console.log(val)
            const hasValue = val => val != null ? val : '' //建立內部函式hasValue，把val用=>指到一個函式，利用三元判斷val的值。
            const text = hasValue(itemText) //呼叫內部函式
            const query = hasValue(queryText)
            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1
        }
    }
}
</script>
